import { Routes, Route } from "react-router";

import { PageNotFound } from "../pageNotFound";
import { ArbitratorInterviewsComponent } from "./arbitrator-interviews";
import { VStack, Image, useBreakpointValue, Box } from "@chakra-ui/react";
import { BannerWithHeading } from "../../generic/layout/bannerWithHeading";
import logoMlUnplugged from "./media/Logo_Website_Button.png";
import { UnpluggedLandingComponent } from "./landing";

export function UnpluggedComponent() {
  const logHeight = useBreakpointValue({ base: 38, md: 46 }, { ssr: false });

  return (
    <VStack spacing={0}>
      <BannerWithHeading
        bgUrl="/media/bg_ml_unplugged.jpg"
        headingText={
          <Image
            src={logoMlUnplugged}
            style={{
              /*                 maxWidth: 320,
                width: "50vw",
                minWidth: logoMinWidth, */
              height: logHeight,
            }}
          />
        }
      />
      <Box py={8}>
        <Routes>
          <Route
            path="arbitrator-interviews/*"
            element={<ArbitratorInterviewsComponent />}
          />
          <Route path="*" element={<UnpluggedLandingComponent />} />
        </Routes>
      </Box>
    </VStack>
  );
}
